module.exports = __webpack_public_path__ + "img/cattunnel05.bb019dd7.jpg";